import { render, staticRenderFns } from "./ModalCompare.vue?vue&type=template&id=49472a8a&scoped=true&"
import script from "./ModalCompare.vue?vue&type=script&lang=js&"
export * from "./ModalCompare.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompare.vue?vue&type=style&index=0&id=49472a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49472a8a",
  null
  
)

export default component.exports